(() => {
  if (window.npFulfilmentReady) return;
  window.npFulfilmentReady = true;

  const updateView = (root) => {
    const selected = root.querySelector('[data-np-method]:checked');
    const delivery = selected?.value === 'Delivery';
    const collection = selected?.value === 'Collection';
    const vehicles = root.querySelector('[data-np-vehicles]');
    const collectionBox = root.querySelector('[data-np-collection]');
    const clearVehicle = root.querySelector('[data-np-clear-vehicle]');
    vehicles.classList.toggle('is-hidden', !delivery);
    vehicles.setAttribute('aria-hidden', String(!delivery));
    collectionBox.classList.toggle('is-hidden', !collection);
    root.querySelectorAll('[data-np-vehicle]').forEach((input) => {
      input.disabled = !delivery;
      if (!delivery) input.checked = false;
    });
    const notes = root.querySelector('[data-np-notes]');
    notes.disabled = !delivery;
    clearVehicle.disabled = !collection;
  };

  const attributesFor = (root) => {
    const method = root.querySelector('[data-np-method]:checked')?.value || '';
    return {
      'Order fulfilment': method,
      'Requested delivery vehicle': method === 'Delivery' ? (root.querySelector('[data-np-vehicle]:checked')?.value || '') : '',
      'Delivery access notes': method === 'Delivery' ? root.querySelector('[data-np-notes]').value : ''
    };
  };

  const persist = (root) => fetch(`${window.Shopify?.routes?.root || '/'}cart/update.js`, {
    method: 'POST',
    headers: {'Content-Type': 'application/json'},
    body: JSON.stringify({attributes: attributesFor(root)})
  }).catch(() => {});

  const validate = (root) => {
    const method = root.querySelector('[data-np-method]:checked');
    if (!method) return 'Please choose Delivery or Collection before checkout.';
    if (method.value === 'Delivery' && !root.querySelector('[data-np-vehicle]:checked')) return 'Please choose a delivery vehicle before checkout.';
    return '';
  };

  document.addEventListener('change', (event) => {
    const root = event.target.closest('[data-np-fulfilment]');
    if (!root) return;
    if (event.target.matches('[data-np-method]')) updateView(root);
    if (event.target.matches('[data-np-method], [data-np-vehicle], [data-np-notes]')) persist(root);
  });

  document.addEventListener('click', (event) => {
    const checkout = event.target.closest('[data-np-checkout], #cartform .additional-checkout-buttons button, #cartform .additional-checkout-buttons a');
    if (!checkout) return;
    const scope = checkout.closest('cart-form') || document;
    const root = scope.querySelector('[data-np-fulfilment]');
    if (!root) return;
    const message = validate(root);
    if (!message) return;
    event.preventDefault();
    event.stopImmediatePropagation();
    window.alert(message);
    root.scrollIntoView({behavior:'smooth', block:'center'});
    root.querySelector('[data-np-method]:not(:checked), [data-np-vehicle]:not(:checked)')?.focus();
  }, true);

  const initialise = () => document.querySelectorAll('[data-np-fulfilment]').forEach(updateView);
  document.addEventListener('DOMContentLoaded', initialise);
  document.addEventListener('shopify:section:load', initialise);
  initialise();
})();
